import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import * as fromEnums from 'projects/Autofacets-Core/src/app/utils/enums';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { Subscription } from 'rxjs';
import { FuelType } from '../../../business-entities/fuel-view-model';
import { SelectListItemViewModel } from '../../../business-entities/select-list-item-view-model';
import { ServiceViewModel } from '../../../business-entities/service-view-model';
import { FuelTypeForMultiselect, ServiceFilterViewModel, ServiceTimeDetailViewModel } from '../../../business-entities/ServiceFilter-viewModel';
import { BrandType, VehicleType } from '../../../business-entities/vehicle-list-view-model';
import { BrandService } from '../../../business-services/brand.service';
import { CheckListBusinessService } from '../../../business-services/check-list.service';
import { DealerServiceBusinessService } from '../../../business-services/dealer-service.service';
import { RentalCarService } from '../../../business-services/rental-car.service';
import { Constant } from './../../../../../../Autofacets-Core/src/app/utils/constant';
import { DealerServiceDetailsViewModel } from './../../../business-entities/dealer-service-details-view-model';
import { DealerServiceViewModel } from './../../../business-entities/dealer-service-view-model';
import { ServicesService } from './../../../business-services/services.service';
import { AdminCommonService } from '../../../services/admin-common.service';

@Component({
    selector: 'app-edit-dealer-service',
    templateUrl: './edit-dealer-service.component.html'
})


export class EditDealerServiceComponent implements OnInit, OnDestroy {

    dealerServiceId: number;
    dealerList: SelectListItemViewModel[];
    selectedDealerId: string;
    selectedDealerServices: DealerServiceViewModel[] = [];
    editDealerServiceForm: FormGroup;
    dealerServiceDetails: DealerServiceDetailsViewModel;
    allServices: ServiceViewModel[] = [];
    allServiceCategory: any[] = [];
    serviceDropdown: { id: number, name: string }[] = [];
    service: any;
    currentlagSub: Subscription;
    serviceCategory: string;
    isFixed:boolean=false
    FixedPrice:any;
    dealerServiceTimeDetailData:any;

    dropdownSettings = {};
   serviceDetails:ServiceTimeDetailViewModel
   ServiceFilterForm: ServiceFilterViewModel[] = []
   makeList: BrandType[] = [];
   vehicleTypes: VehicleType[] = [];
   fuels: FuelType[] = [];
   selectedChildServices:any[]=[];
   selectedChildServicesString:string='';
   deletedServiceFilterId:string='';
   VehicleAge = [];
   Mileage = [];
  LogicOperator=[];
  VATPercentage:number=0


    constructor(
        private formBuilder: FormBuilder,
        private dealerServiceBusinessService: DealerServiceBusinessService,
        private cookieservice: CookieService,
        private toastr: ToastrService,
        public currentLanguageService: CurrentLanguage,
        private servicesService: ServicesService,
        private globalSetting: GlobalSetting,
        private spinner: NgxSpinnerService,
        private activeModal : NgbActiveModal,
        private brandService: BrandService,
        private checkListService: CheckListBusinessService,
        private EditRentalCar: RentalCarService,
        private secureStorage: SecureStorage,
        private adminService: AdminCommonService,

    ) {
        this.Mileage=Constant.Mileage;
        this.VehicleAge=Constant.VehicleAge;
        this.LogicOperator=Constant.LogicOperator;
     }

    ngOnInit(): void {
        this.dropdownSettings = {
            singleSelection: false,
            idField: 'id',
            textField: 'name',
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            itemsShowLimit: 3,
            allowSearchFilter: false,
            maxHeight: 500
          };
          this.serviceDetails={
            makeList:null ,
            modelList:null,
            vehicleTypes: null,
            fuels: null,
            vehicleAge:null,
            mileage:null,
            logicOperator:null

          }
          this.serviceDetails.logicOperator=this.LogicOperator;
          this.serviceDetails.vehicleAge=this.VehicleAge;
          this.serviceDetails.mileage=this.Mileage;
        if (this.currentlagSub) {
            this.currentlagSub.unsubscribe();
          }
        this.dealerServiceBusinessService.isEdit = true;
        this.currentlagSub = this.currentLanguageService.currentLanguage.subscribe(_x => {
            this.initializeForm();
            });
            this.VATPercentage=this.secureStorage.getKeyData('VATPercentage');
    }

    ngOnDestroy(): void {
        this.currentlagSub.unsubscribe();
      }

    async initializeForm(): Promise<void> {
        await this.getAllDetails();

        this.selectedDealerId = this.dealerServiceBusinessService.dealerServiceDetails.dealerId;
        const dealerName = this.dealerServiceBusinessService.dealerServiceDetails.dealerName;
        this.serviceCategory = this.dealerServiceBusinessService.dealerServiceDetails.serviceCategoryName;
        this.service = this.allServices.find(x => x.id === this.dealerServiceBusinessService.dealerServiceDetails.serviceId);
        let serviceName = this.dealerServiceBusinessService.dealerServiceDetails.serviceNo + ' - ' + this.dealerServiceBusinessService.dealerServiceDetails.name;
        let serviceIsFixed = this.service?.isFixed;

        if(this.service === undefined){
            this.isFixed = false
        }
        else{
            this.isFixed = serviceIsFixed?serviceIsFixed:false;
            if(this.service && this.isFixed === true){
                this.FixedPrice = this.service.price
            }
        }
        this.editDealerServiceForm = this.formBuilder.group({
            dealer: [ { value: dealerName, disabled: true }, [Validators.required]],
            serviceCategory: [ { value: this.serviceCategory, disabled: true }, [Validators.required, Validators.min(0)]],
            service: [ { value: serviceName, disabled: true }, [Validators.required, Validators.min(0)]],
            duration: [{value:Utility.ConvertMinutesToTime(this.dealerServiceBusinessService.dealerServiceDetails.duration.toString()), disabled: false },[Validators.required]],
            price: [{ value:this.dealerServiceBusinessService.dealerServiceDetails.price,},[Validators.required]],
            priceInclVAT: [{ value:this.dealerServiceBusinessService.dealerServiceDetails.priceInclVAT,},[Validators.required]],
            description: [this.dealerServiceBusinessService.dealerServiceDetails.description],
            isActive: [this.dealerServiceBusinessService.dealerServiceDetails.isActive],
            isRecommended: [this.dealerServiceBusinessService.dealerServiceDetails.isRecommended],
            isDisplayPriceInWidget: [this.dealerServiceBusinessService.dealerServiceDetails.isDisplayPriceInWidget],
            needAttention:[this.dealerServiceBusinessService.dealerServiceDetails.needAttention],
        });
        this.GetDealerServiceTimeDetails(this.dealerServiceBusinessService.dealerServiceDetails.id);
    }
    GetDealerServiceTimeDetails(Id:number){
        this.spinner.show();
        this.dealerServiceBusinessService.GetDealerServiceTimeDetails(Id).then(result => {
          this.dealerServiceTimeDetailData = result;
          this.MapServiceFilterFormValue();
           this.spinner.hide();
          },
          _error => {
              this.spinner.hide()
            });
      }

      MapServiceFilterFormValue() {
        this.dealerServiceTimeDetailData.forEach((element, index) => {
          let serviceFilterViewModel: ServiceFilterViewModel = {
            Id:0,
            BrandId: null,
            VehicleTypeId: null,
            FuelTypeId: [],
            FuelId: '',
            RangeFunctionForVehicleAge: 0,
            VehicleAge: null,
            LogicFunction: 0,
            Mileage: null,
            RangeFunctionForMileage: 0,
            Duration: null,
            Price: null,
            PriceInclVAT:null,
            IsFixedPrice: false,
            IsShowPrice: false,
            Discount: null,
            Model:null
          };
          this.ServiceFilterForm.push(serviceFilterViewModel);
          this.ServiceFilterForm[index].Id = element.id;
            this.ServiceFilterForm[index].BrandId = element.brandId;
            this.ServiceFilterForm[index].VehicleTypeId = element.vehicleTypeId;
            // this.ServiceFilterForm[index]FuelTypeId: any[] ,
            this.MapFuelTypeId(element.fuelId, this.ServiceFilterForm[index])
          this.ServiceFilterForm[index].FuelId = element.fuelId;
          this.ServiceFilterForm[index].RangeFunctionForVehicleAge = element.rangeFunctionForVehicleAge;
            this.ServiceFilterForm[index].VehicleAge = element.vehicleAge;
            this.ServiceFilterForm[index].LogicFunction = element.logicFunction;
            this.ServiceFilterForm[index].Mileage = element.mileage;
            this.ServiceFilterForm[index].RangeFunctionForMileage = element.rangeFunctionForMileage;
            this.ServiceFilterForm[index].Duration = element.duration;
            this.ServiceFilterForm[index].Price = element.price;
            this.ServiceFilterForm[index].PriceInclVAT = element.priceInclVAT;
            this.ServiceFilterForm[index].IsFixedPrice = element.isFixedPrice;
            this.ServiceFilterForm[index].IsShowPrice = element.isShowPrice;
            this.ServiceFilterForm[index].Discount = element.discount;
            this.ServiceFilterForm[index].Model = element.model
        });
        if(this.dealerServiceTimeDetailData.length===0)
        {
          let serviceFilterViewModel: ServiceFilterViewModel = {
            BrandId: null,
            VehicleTypeId: null,
            FuelTypeId: [],
            FuelId: '',
            RangeFunctionForVehicleAge: 0,
            VehicleAge: null,
            LogicFunction: 0,
            Mileage: null,
            RangeFunctionForMileage: 0,
            Duration: null,
            Price: null,
            PriceInclVAT:null,
            IsFixedPrice: false,
            IsShowPrice: false,
            Discount: null,
            Model:null
          };
          this.ServiceFilterForm.push(serviceFilterViewModel);
        }
      }
    MapFuelTypeId(fuelId: string, serviceFilter: ServiceFilterViewModel) {
        let fuelIds = fuelId.split(',');
        if (this.serviceDetails.fuels && fuelIds) {
            this.serviceDetails.fuels.forEach(x => {
                fuelIds.forEach(y => {
                    if (x.id == parseInt(y)) {
                        serviceFilter.FuelTypeId.push(x);
                    }
                })
            })
        }
    }

    async getAllDetails() {
        this.spinner.show();
        await this.getAllServices();
        await this.GetAllMake();
        await this.GetAllVehicleTypes();
        await this.GetAllFuelTypes();
        this.spinner.hide();
    }

    CheckDuration(event){
      if(event.inputType != 'deleteContentBackward'){
      if(this.editDealerServiceForm.value.duration.length == 2){
        this.editDealerServiceForm.patchValue({
          duration : this.editDealerServiceForm.value.duration + ':',
        })
      }
    }
  }

    RemoveServiceFilter(index: number)
    {
       if(this.ServiceFilterForm[index]?.Id)
       {
         this.deletedServiceFilterId+= this.ServiceFilterForm[index].Id +',';
       }
         this.ServiceFilterForm.splice(index, 1);
       if (this.ServiceFilterForm.length === 0) {
        this.AddServiceFilter(0);
     }
    }

    AddServiceFilter( _index: number) {
      let serviceFilterViewModel: ServiceFilterViewModel = {
        BrandId: null,
        VehicleTypeId: null,
        FuelTypeId: [],
        FuelId:'',
        RangeFunctionForVehicleAge:0,
        VehicleAge:null,
        LogicFunction:0,
        Mileage:null,
        RangeFunctionForMileage:0,
        Duration:null,
        Price:null,
        PriceInclVAT:null,
        IsFixedPrice:false,
        IsShowPrice:false,
        Discount: null,
        Model: null
      };
      this.ServiceFilterForm.push(serviceFilterViewModel);
    }

    async GetAllMake(): Promise<void> {
        await this.brandService.GetBrandDropdown().then(data => {
          this.makeList = data.responseObject;
          this.serviceDetails.makeList=this.makeList;
        });
      }

      async GetAllVehicleTypes(): Promise<void> {
        await this.checkListService.getVehicleTypes().then(data => {
            this.vehicleTypes = data.responseObject.filter(x => x.isDisplay);
            this.serviceDetails.vehicleTypes=this.vehicleTypes;
        });
      }

      async GetAllFuelTypes(): Promise<void> {
        await this.EditRentalCar.GetFuelTypes().then(data => {
          this.fuels = data.responseObject.result.slice();
          this.serviceDetails.fuels=this.MapFuelType(this.fuels);
        });
      }

      MapFuelType(fuelList:FuelType[])
      {
        let fuels: FuelTypeForMultiselect[]=[];
        fuelList.forEach(element => {
          let fuelDetail:FuelTypeForMultiselect=
          {
            id:element.id,
            fuelType:element.fuelType,
            description:element.description,
            fuelCodeAndType:element.fuelType+ ' - '+element.description
          }
          fuels.push(fuelDetail);
        });
        return fuels;
      }



    onBlur(event) {
        this.dealerServiceBusinessService.dealerServiceDetails.price = event.target.value;
        let priceVal= JSON.parse(JSON.stringify(event.target.value));
        priceVal = Number(priceVal.toString().replace(',', '.'));
        this.dealerServiceBusinessService.dealerServiceDetails.priceInclVAT = Utility.GetPriceInludingVAT(priceVal,this.VATPercentage).toString();
      }

      onChecked(obj: any, isChecked: boolean){
        //TODO: 
      }

    async getAllServices() {
        let language = this.cookieservice.get('userSelectedLanguage')
        await this.servicesService.getService(language,0,true)
            .then((response) => {
                this.allServices = response;
            });
    }

    get cpf() {
        return this.editDealerServiceForm.controls;
    }

    isDigit(event): void {
        const isDigit = Utility.isDigit(event);
        if (!isDigit) {
            event.preventDefault();
        }
    }

    onSubmit(): void {
        if (this.editDealerServiceForm.invalid) {
            return;
        }
        const viewModel = this.createViewModal();
        this.spinner.show();
        this.dealerServiceBusinessService.editDealerServices(viewModel).then((response) => {
            this.spinner.hide();
            if(response.responseObject?.updatedRows[0])
            {
              if(response.responseObject.updatedRows[0].updatedRowCount)
              {
                this.toastr.success(fromEnums.ToastrMessages.DealerServiceUpdated);
                if(response.responseObject.unassociatedChildSrvices
                  && response.responseObject.unassociatedChildSrvices.length>0)
                {
                  const childServiceList = response.responseObject.unassociatedChildSrvices
                  .map(element => element.serviceName)
                  .join(',');
              this.adminService.showUnassociatedChildServiceWarning(childServiceList)
                }
                this.activeModal.close({ success: true });
              }
              else
              {
                this.toastr.error(fromEnums.ToastrMessages.DealerServiceUpdateFalied);
              }
            }
        });
    }

    createViewModal(): DealerServiceViewModel {
        const formValue = this.editDealerServiceForm.value;
        let durationInTime  =formValue.duration === undefined ? this.dealerServiceBusinessService.dealerServiceDetails.duration : formValue.duration
        let duration = Utility.ConvertTimeToMinutes(durationInTime)
        return {
            id: this.dealerServiceBusinessService.dealerServiceDetails.id,
            dealerId: this.selectedDealerId,
            serviceId: this.dealerServiceBusinessService.dealerServiceDetails.serviceId,
            duration: duration,
            price: this.globalSetting.getFormattedprice(formValue.price === undefined ? this.dealerServiceBusinessService.dealerServiceDetails.price.toString() : formValue.price),
            isActive: formValue.isActive,
            name: this.dealerServiceBusinessService.dealerServiceDetails.name,
            description: formValue.description,
            serviceCategoryId: this.dealerServiceBusinessService.dealerServiceDetails.serviceCategoryId,
            logo: this.dealerServiceBusinessService.dealerServiceDetails.logo ? this.dealerServiceBusinessService.dealerServiceDetails.logo : '',
            isDisplayPriceInWidget: formValue.isDisplayPriceInWidget,
            serviceCategoryName: this.serviceCategory,
            serviceCategoryList: [],
            languageCode:this.cookieservice.get('userSelectedLanguage'),
            needAttention:formValue.needAttention,
            deletedServiceFilterId:this.deletedServiceFilterId
        } as DealerServiceViewModel;
    }

    OnClose(){
      this.activeModal.close({success:false})
    }
}
